import Splide from '@splidejs/splide';
import "./components/item/ItemImageCarousel";
import "./components/events/events";
import "./components/item/Carousel";
import LazyLoad from "vanilla-lazyload";
/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself
const Vue = window.Vue;
var initShopbuilderScripts = false;
/*
export default {
    mounted() {
     
    }
  }
*/

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}


/*
$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    $('.owl-widget-home-carousel').owlCarousel({
            loop:true,
            nav:true,
            items: 1
        })
   console.log("DROP")
});*/
$(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function(event, eventData, widgetElement)
{
    if(!initShopbuilderScripts){
        initSlider();
        initShopbuilderScripts = true;
    }
    
});
setInterval(function(){ 
    if($(document).width()<768){
        var elem = $('.top-top-bar .active-point');
        $(elem).removeClass('active-point')
        if($(elem).next('li').length>0){
            $(elem).next('li').addClass('active-point');
        }else{
            $('.top-top-bar li').first().addClass('active-point');
        }

    }
}, 3000);
function initSlider(){
    if($('.splide-slider').length > 0){
        new Splide('.splide-slider',{
            mediaQuery: 'min',
            type   : 'loop',
            pagination: true,
            arrows: false,
            perPage: 1,
            perMove: 1,
            autoplay: true,
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: "play"
              },
            breakpoints:{
                1200: {
                    arrows: true,
                    pagination: false,
                },
            }
          }).mount();
        
    }
    if($('.splide-slider-cats').length > 0){
        $('.splide-slider-cats').each(function(){
            new Splide(this, {
                fixedWidth: '200px',
                drag   : 'free',
                gap    : '30px',
                mediaQuery: 'min',
                pagination: false,
                arrows: false,
                breakpoints:{
                    768: {
                        perPage: 3,
                        fixedWidth: false,
                        arrows: true
                    },
                    992: {
                        arrows: false,
                        destroy: true,
                        gap    : '30px'
                    },
                }
              }).mount();
        })
       
    }
}
$(document).ready(function(){
  
    const lazyContent = new LazyLoad({
        elements_selector: '.rf-lazy',
        use_native: false,
        threshold: 500 // <-- there you go
    });
    
    

    initSlider(); 
})
function checkForTagId(tags, tagId){
    if(tags == null){
        return false;
    }
    var hasTag = false;
    tags.forEach(function(tagItem){
        if(tagItem.id == tagId){
            hasTag = true;
        }
    });
    return hasTag;
}
window.setCookie = setCookie;
window.getCookie = getCookie;
window.checkForTagId = checkForTagId;
//window.initHomeSlider = initHomeSlider;
